import { queryOptions } from '@tanstack/react-query';
import axios from 'axios';
import type { Breadcrumb } from '@/models/breadcrumb';
import type { EntityView } from '@/models/entity-view';

export const getEntityQueryOptions = (entityTypeId: string, id: string) => {
  return queryOptions({
    queryKey: [entityTypeId, id],
    queryFn: async () => {

      if (entityTypeId == null || id == null) {
        return null;
      }

      const response = await axios.get<GetEntityType<any>>(
        `/${entityTypeId}/${id}`
      );
      if (response.status !== 200) {
        throw new Error('Failed to fetch entity');
      }
      return response.data;
    },
  });
};

export interface GetEntityType<T> {
  breadcrumbs?: Array<Breadcrumb>;
  entity?: T;
  view?: EntityView;
}
